import { createStore, applyMiddleware } from "redux";
import { loadingBarMiddleware } from "react-redux-loading-bar";
import { reducers } from "../reducers/reducers";

export const store = createStore(
  reducers,
  applyMiddleware(loadingBarMiddleware())
);
